<script>
export default {
  name:'active',
  data(){
    return{
      sid:'',
      size1:10,
      page1:1,
      activeTab:'0',
      gameList:[],
    }
  },
  components:{

  },
  watch:{
    // 监控参数变化更新游戏列表接口数据
    searchParams:function(newVal,oldVal) {
      if(newVal.status!==oldVal.status){
        this.page1 = 1;
        this.gameList = [];
      }
      this.getListGame();
    },
  },
  computed:{
    // 监控参数变化更新游戏列表接口数据
    searchParams() {
      return {
        pageSize:this.size1,//每页数量
        pageNum:this.page1,//当前页码
        status:this.activeTab,// status 活动状态（0开启，1关闭）
        category:1,//1-调查（investigate）,2-活动activity
        orderByColumn:'createTime',//排序列
        isAsc:'desc',//排序的方向desc或者asc
      };
    },
  },
  methods:{
    showModal(type,item){
      if(type==='verifyModal'){
        this.$router.push({path:'/activeList',query:{'id':item.id,'sid':this.sid}})
      }
    },
    getListGame(){
      this.$http.marketingQuestionnaire_list(this.searchParams).then((res)=>{
        if(res){
          if(res.code===200){
            this.gameList = res.rows;
          }else{
            if(res.msg){
              this.$toast.fail(res.msg);
            }
          }
        }
      });
    },
  },
  created(){
    if(this.$route.query.sid){
      this.sid = this.$route.query.sid;
    }
    this.getListGame();
  }
}
</script>

<template>
  <div id="" class="">
    <div class="content">
      <div class="tabs">
        <van-tabs v-model="activeTab" animated swipeable sticky>
          <van-tab title="进行中" name="0"></van-tab>
          <van-tab title="已结束" name="1"></van-tab>
        </van-tabs>
      </div>
      <div class="tab-content active" v-if="gameList.length>0">
        <div class="activity-card" v-for="(item,index) in gameList" :key="index">
          <img :src="item.imageOssIdUrl" v-if="item.imageOssIdUrl" alt="活动图片" class="activity-image">
          <div class="activity-content">
            <div class="activity-title">{{ item.title }}</div>
            <div class="activity-desc">{{ item.description }}</div>
            <div class="activity-footer">
              <div class="activity-date" v-if="item.createTime">{{item.createTime}}</div>
              <div class="activity-date" v-if="item.startTime&&item.endTime">{{ item.startTime&&item.startTime.substring(0,10) }} 至 {{ item.endTime&&item.endTime.substring(0,10) }}</div>
              <button class="btn btn-primary" @click="showModal('verifyModal',item)" v-if="item.status===0">待办</button>
              <button class="btn btn-primary" disabled="disabled" v-else>已结束</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card" style="text-align: center" v-else>
        暂无数据！
      </div>
    </div>
  </div>
</template>
<style scoped lang="scss">
</style>